import { memo } from 'react';

interface AccordionContentProps {
  children: React.ReactNode;
  open: boolean;
  id?: string;
  ariaLabelledBy?: string;
}

export const AccordionContent = memo(
  ({ children, open, id, ariaLabelledBy }: AccordionContentProps) => {
    if (!open) return null;

    return (
      <div
        id={id}
        className="ui-duration-600 ui-w-full ui-overflow-hidden ui-rounded-control-sm ui-opacity-100 ui-transition-all ui-ease-in-out"
        aria-hidden={false}
        aria-labelledby={ariaLabelledBy}
      >
        {children}
      </div>
    );
  },
);

AccordionContent.displayName = 'AccordionContent';
